export default __webpack_public_path__ + "static/media/larsi-min.f6e656a0.png";